// const logo = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/marriott-executive-apartments/logo.png';
// const heroImageLarge = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/marriott-executive-apartments/heroLarge.png';
// const heroImageSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/marriott-executive-apartments/heroSmall.png';
// const heroImageXSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/marriott-executive-apartments/heroXSmall.png';
// const exploreImageLarge = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/marriott-executive-apartments/exploreLarge.png';
// const exploreImageSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/marriott-executive-apartments/exploreSmall.png';
// const exploreImageXSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/marriott-executive-apartments/exploreXSmall.png';
import { themePrimaryColorsBrand } from '../style-constants';
import { baseURL } from '../../config';

export default {
  extendedTheme: () => ({
    logo: (new Image().src =
      `${baseURL}/public-assets/dlz2/images/themes/marriott-executive-apartments/logo.png`),
    heroImageLarge: (new Image().src =
      `${baseURL}/public-assets/dlz2/images/themes/marriott-executive-apartments/heroLarge.png`),
    exploreImageLarge: (new Image().src =
      `${baseURL}/public-assets/dlz2/images/themes/marriott-executive-apartments/exploreLarge.png`),
    palette: {
      primary: {
        main: themePrimaryColorsBrand.MEA,
      },
      secondary: {
        main: '#ebe3d8',
      },
      primaryBtnHover: {
        main: '#342600',
      },
      buttonText: {
        main: '#fff',
      },
      interaction: {
        main: '#8e5900',
      },
      text: {
        primary: '#1c1c1c',
      },
      link: {
        primary: '#1c1c1c',
      },
      highlightTextColor: {
        main: '#1c1c1c',
      },
    },
    typography: {
      useNextVariants: true,
      fontFamily: [
        '"ProximaNova-Regular"',
        '"Roboto"',
        '"Helvetica"',
        '"Arial"',
        'sans-serif',
      ].join(','),
    },
  }),
  typography: (theme, remCalc) => {
    return {
      h1: {
        fontFamily: 'proxima-nova-semibold',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(54),
          lineHeight: 1.11,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(34),
          lineHeight: 1.24,
        },
      },
      h2: {
        fontFamily: 'proxima-nova-semibold',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(40),
          lineHeight: 1.15,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(30),
          lineHeight: 1.2,
        },
      },
    };
  },
  extraTypography: (theme, remCalc) => {
    return {
      hero: {
        fontFamily: 'proxima-nova-semibold',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(44),
          lineHeight: 1.09,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(44),
          lineHeight: 1.09,
        },
      },
      card: {
        fontFamily: 'proxima-nova-semibold',
        fontWeight: 'bold',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(38),
          lineHeight: 1.16,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(28),
          lineHeight: 1.21,
        },
      },
    };
  },
};
